import React, { useCallback } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { ROLES } from "../../../model/roles";

const stripePromise = loadStripe(
  //"pk_test_51P3aC3JqfbmMuCqrIMYUcT4xyj02q6iR1z00AmS4oDfRoHH4fPPR2nwIpwdEp405S65QVnowMdSA7FbJnzjVOCXh00LewEEXgw",
  "pk_live_51P3aC3JqfbmMuCqrjukipqMUbK9btTOPWTZA728UU2DRKkfOU8NmcHM4bpnd1xd3L9h5du588qCcoKCfAcOuduhp0089vnTZIS",
  {
    locale: 'it'
  }
);

const CheckoutStripeForm = () => {
  const { REACT_APP_REST_ENDPOINT } = process.env;
  const user = useSelector((state) => state.user?.userData);
  const location = useLocation();
  const courseData = location.state && location.state?.courseData;
  const courses = Array.isArray(courseData) ? courseData : [courseData];
 
  const fetchClientSecret = useCallback(() => {
    let jsonData = {};
    
    if (user.role === ROLES.PARTNER) {
      jsonData = {
        classi: courses.map(course => course?.id_classe),
        username: courses[0]?.corsistaUsername
      };
    } else {
      jsonData = {
        classi: courses.map(course => course?.id_classe),
        username: user?.sub,
        idSP: localStorage.getItem("idSP")
      };
    }

    const token = localStorage.getItem("token");
    
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(jsonData)
    };

    return fetch(
      `${REACT_APP_REST_ENDPOINT}/stripe/create-checkout-session`,
      requestOptions
    )
      .then((res) => {
        if (!res.ok) {
          return res.text().then(text => {
            throw new Error(text || 'Errore nella creazione della sessione di checkout');
          });
        }
        return res.json();
      })
      .then((data) => {
        return data.clientSecret.clientSecret;
      })
      .catch((error) => {
        console.error('Errore:', error);
        throw error;
      });
  }, [courses, user]);

  const options = { 
    fetchClientSecret
  };

  return (
    <div id="checkout" className="container">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <EmbeddedCheckoutProvider 
            stripe={stripePromise} 
            options={options}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      </div>
    </div>
  );
};

export default CheckoutStripeForm;
